import { ColDef, type ICellRendererParams } from "ag-grid-community";
import { Typography } from "@mui/material";
import { jiraIssuesColumnDef } from "../common/jiraIssuesColumnDef";
import { tagsColumnDef } from "../common/tagsColumnDef";
import { smartTagsColumnDef } from "../common/smartTagsColumnDef";
import { regionColumnDef } from "../common/regionColumnDef";
import { resourceCreatedByColumnDef } from "../common/resourceCreatedByColumnDef";
import { forecastedEOMColumnDef } from "../common/forecastedEOMColumnDef";
import { getResourceCreationTimeColumnDef } from "../common/getResourceCreationTimeColumnDef";
import { resourceTotalSpendColumnDef } from "../common/resourceTotalSpendColumnDef";
import { getResourceSizeColumnDef } from "../common/getResourceSizeColumnDef";
import { FilteredEcsWorkloadResourceItem } from "@/services/cloudchipr.api";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";
import { taskColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/taskColumnDef";
import { billingCostColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/billingCostColumnDef";
import { getListingPriceColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/listingPriceColumnDef";
import { getResourceMetricsColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceMetricsColumnDef";

export const ecsWorkloadColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef(),

  forecastedEOMColumnDef,
  billingCostColumnDef,
  getListingPriceColumnDef("ecs_workload"),

  { field: "resource.type", headerName: "Type" },

  getResourceCreationTimeColumnDef("Start time"),

  getResourceMetricsColumnDef("CPU Max", "cpu_max", "ecs_workload"),

  getResourceMetricsColumnDef(
    "Memory Max",
    "mem_used_percent_max",
    "ecs_workload",
  ),

  resourceCreatedByColumnDef,

  resourceTotalSpendColumnDef,

  {
    field: "resource.cpu_reservation",
    headerName: "CPU Reservation Per Task",
    cellRenderer: ({
      data,
    }: ICellRendererParams<FilteredEcsWorkloadResourceItem>) => {
      if (!data) {
        return null;
      }

      const reservation = data?.resource?.cpu_reservation;

      return <Typography variant="body2">{reservation} vCPU</Typography>;
    },
  },

  getResourceSizeColumnDef({
    propName: "memory_reservation",
    headerName: "Memory Reservation Per Task",
  }),

  getResourceSizeColumnDef({
    propName: "storage",
    headerName: "Storage Per Task",
  }),

  { field: "resource.status", headerName: "Status" },

  { field: "resource.capacity_provider", headerName: "Capacity Provider" },

  { field: "resource.task_count", headerName: "Task Count" },

  regionColumnDef,

  { field: "resource.revision", headerName: "Revision" },

  tagsColumnDef,
  smartTagsColumnDef,
  taskColumnDef,
  jiraIssuesColumnDef,
];
